import { Link } from "react-router-dom";
import { categoryMeta } from "@/mocks/media";

export default function CategoryEntries() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 pt-12 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {categoryMeta.map((c, i) => (
          <Link
            key={c.key}
            to={`/category/${encodeURIComponent(c.key)}`}
            className={`group relative flex items-center gap-4 overflow-hidden rounded-lg border p-5 transition-all duration-300 hover:-translate-y-1 ${
              i === 0
                ? "border-primary-400/40 bg-primary-500/10"
                : "border-background-200/70 bg-background-100 hover:border-accent-500/50"
            }`}
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-md ${
                i === 1
                  ? "bg-accent-500 text-background-50"
                  : "bg-primary-500 text-foreground-950"
              }`}
            >
              <i className={`${c.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">
                {c.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {c.subtitle}
              </p>
            </div>
            <i className="ri-arrow-right-line ml-auto shrink-0 text-xl text-foreground-500 transition-transform group-hover:translate-x-1 group-hover:text-accent-400"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}